import styled from 'styled-components';
import { CustomDialog } from '../../../../../../../components/dialog/v1/CustomDialog';
import CustomBlockButton from '../../../../../../../components/button/CustomBlockButton';
import { useState } from 'react';
import _ from 'lodash';
import { CustomLabelInput } from '../../../../../../../components/input/CustomLabelInput';
import { useApiInfoContextValueHook } from '../../../../../../../contexts/ApiInfoContext';
import { SellertoolSignatureUtils } from '../../../../../../../utils/sellertool-signature-utils';
import { ReturnExchangeDownloadFormsApi } from '../../../../../../../apis/ReturnExchangeDownloadFormsApi';
import { useFetcher } from '../../../../fetcher/useFetcher';
import { CustomBackdropController } from '../../../../../../../components/backdrop/default/v1';
import { v4 as uuidv4 } from 'uuid';

const StyledHeader = styled.div`
    padding: 10px;
`;

const StyledBody = styled.div`
    padding: 10px;
    display: flex;
    flex-direction: column;
    gap: 10px;
    input{
        border: 1px solid #e0e0e0;
        border-radius: 3px;
    }
`;

const StyledFooter = styled.div`
    padding: 10px;
    button{
        background-color: #333;
        border: none;
        color: #fff;
        font-weight: 600;
        border-radius: 3px;
    }
`;

export function ModalCopyCreate({
    open,
    onClose,
    selectedDownloadForm
}) {
    const apiInfoContextValueHook = useApiInfoContextValueHook();
    const fetcher = useFetcher();

    const copiedDownloadForm = _.cloneDeep(selectedDownloadForm);

    const [formData, setFormData] = useState({
        ...copiedDownloadForm,
        name: `${copiedDownloadForm.name} 복사본`,
        uuid: uuidv4()
    });

    const handleSubmit = async () => {
        const timestamp = Date.now().toString();
        const signature = SellertoolSignatureUtils().generateSigniture({
            apiKey: apiInfoContextValueHook?.apiInfo?.apiKey,
            secretKey: apiInfoContextValueHook?.apiInfo?.secretKey,
            timestamp: timestamp
        })

        const headers = {
            'x-sellertool-apiKey': apiInfoContextValueHook?.apiInfo?.apiKey,
            'x-sellertool-timestamp': timestamp,
            'x-sellertool-signiture': signature
        }

        const body = {
            formDatas: [formData]
        }

        const response = await ReturnExchangeDownloadFormsApi().createList({ headers: headers, body: body })

        CustomBackdropController().showBackdrop();
        if (response?.content) {
            fetcher.fetchReturnExchangeDownloadForms();
            onClose();
        }
        CustomBackdropController().hideBackdrop();
    }
    return (
        <>
            <CustomDialog
                open={open}
                onClose={() => onClose()}
            >
                <StyledHeader>
                    <CustomDialog.Header>
                        <CustomDialog.Header.Fake />
                        <CustomDialog.Header.Title>
                            복사생성
                        </CustomDialog.Header.Title>
                        <CustomDialog.Header.Close onClick={onClose} />
                    </CustomDialog.Header>
                </StyledHeader>
                <StyledBody>
                    <CustomLabelInput>
                        <CustomLabelInput.Input
                            type='text'
                            value={formData.name || ''}
                            onChange={(e) => setFormData({ ...formData, name: e.target.value })}
                        />
                        <CustomLabelInput.Label>
                            이름
                        </CustomLabelInput.Label>
                    </CustomLabelInput>
                    <CustomLabelInput>
                        <CustomLabelInput.Input
                            type='text'
                            value={formData.description || ''}
                            onChange={(e) => setFormData({ ...formData, description: e.target.value })}
                        />
                        <CustomLabelInput.Label>
                            설명
                        </CustomLabelInput.Label>
                    </CustomLabelInput>
                </StyledBody>
                <StyledFooter>
                    <CustomBlockButton
                        type='button'
                        onClick={handleSubmit}
                    >
                        복사생성
                    </CustomBlockButton>
                </StyledFooter>
            </CustomDialog>
        </>
    );
}